import { Desktop } from 'styles/MediaQueries';
import PartnerLogo from 'registration/lead/PartnerLogo';
import React from 'react';

const containerStyle = {
  fontFamily: 'Arimo',
  textAlign: 'center',
  color: '#0528A0',
  fontWeight: '700'
};

const logoContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%'
};

const headerStyle = {
  fontSize: '1.5rem',
  margin: '1rem 0',

  [Desktop]: {
    fontSize: '1.75rem'
  }
};

const secondaryTextStyle = {
  fontSize: '1.25rem',
  marginBottom: '1rem',

  [Desktop]: {
    fontSize: '1.5rem'
  }
};

const tertiaryTextStyle = {
  fontSize: '0.875rem',
  fontWeight: '400',
  color: 'black',

  [Desktop]: {
    fontSize: '1rem'
  }
};

export default function PartnerBranding({
  partnerId,
  partnerName,
  alternateSecondaryText = 'Loan Application',
  alternateTertiaryText = 'Review, edit and submit to check your eligibility.'
}) {
  return (
    <div css={containerStyle}>
      <div css={logoContainerStyle}>
        <PartnerLogo partnerId={partnerId} partnerName={partnerName} />
      </div>

      <h1 css={headerStyle}>Welcome to Opploans!</h1>

      <h2 css={secondaryTextStyle}>{alternateSecondaryText}</h2>

      <p css={tertiaryTextStyle}>{alternateTertiaryText}</p>
    </div>
  );
}
